<div class="devices-google-map">
    <google-map appMapTheme [options]="mapOptions" [width]="'100%'" [height]="'100%'" class="map-container">
    </google-map>
</div>